import { defineMessages } from 'react-intl';

/**
 * The copy of the LaziiBee tour (design: onboarding b1-b7, copy table in
 * docs/superpowers/design-reference/music24-onboarding/README.md). Product copy, not ASD-STE100.
 * The facts in this copy come from the LaziiBee demo data of music24-api (`DemoArtist/fixtures`):
 * 14 rollout posts from release day −14 to +7, 412 Forests pre-saves, Forests out on a Friday 5 to
 * 11 days ahead, and a release-day jump of Swamps (the numbers stop names no song). The demo dates move with today; the numbers do
 * not. Change the copy and the fixtures together.
 */
export const tourMessages = defineMessages({
  eyebrow: { id: 'app.sml.tour.eyebrow', defaultMessage: 'Example · LaziiBee' },
  count: { id: 'app.sml.tour.count', defaultMessage: '{n} of {count}' },
  // The second line of the counter (design b1: the stop number on top, "of 5" under it).
  countOf: { id: 'app.sml.tour.countOf', defaultMessage: 'of {count}' },
  back: { id: 'app.sml.tour.back', defaultMessage: 'Back' },
  next: { id: 'app.sml.tour.next', defaultMessage: 'Next' },
  exit: { id: 'app.sml.tour.exit', defaultMessage: 'Exit tour' },
  kitTitle: {
    id: 'app.sml.tour.stop.kit.title',
    defaultMessage: 'Every post and video for the release, from one song.',
  },
  kitBody: {
    id: 'app.sml.tour.stop.kit.body',
    defaultMessage:
      'LaziiBee added Forests once. MUSIC24 made the stories, posts, videos and cover sizes, all in one look.',
  },
  kitShort: { id: 'app.sml.tour.stop.kit.short', defaultMessage: 'Made by MUSIC24 from Forests, in one look.' },
  planTitle: {
    id: 'app.sml.tour.stop.plan.title',
    defaultMessage: 'Check the plan once. It posts on time, everywhere.',
  },
  // A new id: the old copy ("to six weeks after release day") did not match the demo rollout.
  planBody: {
    id: 'app.sml.tour.stop.plan.bodyRollout',
    defaultMessage:
      '14 posts from the pre-save announcement two weeks before release day to one week after, on TikTok, Instagram, YouTube, Facebook and Threads.',
  },
  linkTitle: { id: 'app.sml.tour.stop.link.title', defaultMessage: 'Fans pre-save before release day.' },
  linkBody: {
    id: 'app.sml.tour.stop.link.body',
    defaultMessage:
      'One link for Forests with every service. 412 fans wait for Friday, and they stay yours for the next song.',
  },
  numbersTitle: { id: 'app.sml.tour.stop.numbers.title', defaultMessage: 'See what brought you new listeners.' },
  // A new id: the old copy named Swamps in a tour about Forests (QA F31).
  numbersBody: {
    id: 'app.sml.tour.stop.numbers.bodyReel',
    defaultMessage: 'Streams next to the days LaziiBee posted. A release-day reel brought most of the jump.',
  },
  homeEyebrow: { id: 'app.sml.tour.stop.home.eyebrow', defaultMessage: 'Your turn' },
  homeTitle: { id: 'app.sml.tour.stop.home.title', defaultMessage: 'Now make yours.' },
  homeBody: {
    id: 'app.sml.tour.stop.home.body',
    defaultMessage: 'Add one song. MUSIC24 starts on your kit right away, and Home shows you the rest, step by step.',
  },
  homeShort: {
    id: 'app.sml.tour.stop.home.short',
    defaultMessage: 'Add one song. MUSIC24 starts on your kit right away.',
  },
  addSong: { id: 'app.sml.tour.addSong', defaultMessage: 'Set up my own song' },
  memberTitle: { id: 'app.sml.tour.member.title', defaultMessage: 'Now run your releases like this.' },
  memberBody: {
    id: 'app.sml.tour.member.body',
    defaultMessage: 'Every artist in {workspace} gets the same kit, plan and numbers.',
  },
  memberOpen: { id: 'app.sml.tour.member.open', defaultMessage: 'Open the workspace' },
  exited: {
    id: 'app.sml.tour.exited',
    defaultMessage: 'Tour closed. LaziiBee stays in your artist list as an example.',
  },
});
